import React, { CSSProperties, useCallback, useEffect, useState } from 'react';
import { getCosIDFromUrl } from '@hooks/useImageCache';
import { formatUrl, formatUrlFormatWebp } from '@utils/imageLoad';
import useImageLoadHooks from '@hooks/useImageWidthHooks';
export interface CosImageProps {
  href: string;
  className?: string;
  style?: CSSProperties;
  width?: number;
  parentRef?: any;
  disabledCosId?: boolean;
}

const CosImage: React.FC<CosImageProps> = (props) => {
  const { className, style, href, width, parentRef, disabledCosId } = props;
  const [cosId, setCosId] = useState('');
  const [src, setSrc] = useState('');
  const { domWidth } = useImageLoadHooks(parentRef, width);
  // 获取优化的图片链接
  const [optizeUrl, updateUrl] = useState(src);
  // 优先使用webp格式
  useEffect(() => {
    if (src) {
      const url = formatUrlFormatWebp(src, width);
      updateUrl(url);
    }
  }, [src, width]);

  const onError = useCallback(() => {
    if (!domWidth || !src) return;
    const url = formatUrl({
      url: src,
      imgWidth: domWidth,
    });
    updateUrl(url);
  }, [src, domWidth]);

  useEffect(() => {
    const id = getCosIDFromUrl(href);
    if (cosId !== id || disabledCosId) {
      setCosId(id);
      setSrc(href);
    }
  }, [href, cosId, disabledCosId]);
  return (
    <img className={className} style={style} src={optizeUrl} draggable={false} onError={onError} />
  );
};

export default CosImage;
